import React from "react";
import { Tooltip } from "antd";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";

const FacilityLink = ({ id, text, action }) => {
  const { navigateToFacilityDetail } = useSmartNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    if (action) {
      navigateToFacilityDetail(id);
    }
  };

  return (
    <Tooltip title={text}>
      <a
        onClick={handleClick}
        style={{
          display: 'block',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: '100%',
          cursor: 'pointer'
        }}
      >
        {text}
      </a>
    </Tooltip>
  );
};

export default FacilityLink;

